<div class="row book-appointment-container" cdkScrollable>
  <div class="col-12 book-appointment-header">
    <button type="button" (click)="onHide()" mat-icon-button aria-label="Close book appointment">
      <mat-icon>arrow_back_ios</mat-icon>
    </button>
    <span class="ms-sm-2">New Appointment</span>
    <div class="d-md-none user-profile">
      <mat-icon [matMenuTriggerFor]="userMenu" class="pointer">person_outline</mat-icon>
      <mat-menu #userMenu="matMenu" xPosition="after" class="user-menu-collapse">
        <cva-side-nav-user-menu-items></cva-side-nav-user-menu-items>
      </mat-menu>
    </div>
  </div>
  <form [formGroup]="bookAppointmentForm" class="px-4 book-appointment-form">

    <div class="position-relative searchContainer">
      <div class="col-12 mb-2 position-relative d-flex flex-row align-items-center justify-content-between"
        id="providerName">
        <label class="form-label" for="provider">
          Provider Name *
        </label>
        <input type="text" class="form-control provider-input" matInput formControlName="provider" [matAutocomplete]="auto"
          (input)="searchProviderByName()" (blur)="checkProvider()">
        <mat-autocomplete #auto="matAutocomplete" class="provider-autocomplete-panel"
          (optionSelected)="selectedProvider($event)">
          <mat-option *ngFor="let item of filteredProviders" [value]="item.firstName +' '+ item.lastName">
            <div class="provider-option-row">
              <span class="provider-option-name">{{item.firstName +' '+ item.lastName}}</span>
            </div>
          </mat-option>
        </mat-autocomplete>
      </div>
    </div>

    <div class="position-relative searchContainer">
      <div class="col-12 mb-2 position-relative d-flex flex-row align-items-center justify-content-between"
        id="patientId">
        <label class="form-label" for="patientId">
          Patient Id *
        </label>
        <input type="text" class="form-control" formControlName="patientId" (blur)="searchPatientById()"
          style="padding-right: 30px;" (ngModelChange)="patientUpdated()">
        <button type="button" class="search-icon btn-invisible" (click)="searchPatientById()">
          <i class="bi bi-search"></i>
        </button>
      </div>
    </div>

    <div class="position-relative searchContainer" id="patientName">
      <label class="form-label" for="patient">
        Patient Name
      </label>
      <div class="form-control patientName-field">
        <span>{{patient?.value}}</span>
      </div>
    </div>

    <div class="position-relative searchContainer" id="patientDOB">
      <label class="form-label" for="dob">DOB</label>
      <div class="form-control patientName-field">
        <span>{{dob?.value | date:"d MMM, y"}}</span>
      </div>
    </div>

    <div class="col-12 mb-2 date-filter-container">
      <label class="form-label date-label" for="startDate">Date</label>
      <div class="date-field form-control">
        <span class="date-text">{{startDate?.value | date:"d MMM, y"}}</span>
        <div class="date-input">
          <input matInput [matDatepicker]="datepicker" formControlName="startDate" class="aptmt-date-field"
            [min]="currentDate" (dateChange)="updateSlots()">
          <mat-datepicker-toggle matIconSuffix [for]="datepicker">
          </mat-datepicker-toggle>
          <mat-datepicker #datepicker></mat-datepicker>
        </div>
        <button type="button" class="no-button calendar-icon" (click)="datepicker.open()">        
          <mat-icon fontIcon="calendar_month" ></mat-icon>
        </button>
      </div>
    </div>

    <div class="col-12 mb-2 slot-section">
      <div class="form-label slot-label">
        <span class="float-start ">Available Time Slots*
          <button type="button" (click)="updateSlots(true)" class="no-button">
            <img [src]="cvaUI_url+ '/assets/icons/refresh.svg'" title="Refresh" alt="Refresh Icon"
              class="refresh-icon pointer" />
          </button>
        </span>
        <span class="float-end slot-legend d-flex ">
          <i class="bi bi-square-fill available-legend me-1"></i>
          Available
          <i class="bi bi-square-fill booked-legend mx-1"></i>
          Booked
        </span>
      </div>
      <div class="slot-list p-2" [class.slot-req]="isScheduleClicked && startTime?.invalid">
        @if(isLoading){
        <div class="slots-loader" role="status" aria-live="polite">
          <span class="spinner-border spinner-border-sm me-2" aria-hidden="true"></span>
          <span>Loading available time slots...</span>
        </div>
        } @else {
        @if(slots.length > 0){
        <button type="button" class="no-button slot" *ngFor="let slot of slots" [ngClass]="{
              'available-slot': slot.status === 'free',
              'booked-slot': slot.status === 'busy',
              'selected-slot': selectedSlot === slot
            }" (click)="selectSlot(slot)">
          <p>{{slot.start | date:'HH:mm'}}</p>
        </button>
        }@else if(startDate?.value) {
        <div class="no-slots-message">
          {{ noSlotsMessage }}
        </div>
        }
        }
      </div>
    </div>


    <div class="col-12 mb-2 time-section">
      <div class="row">
        <div class="durationTime">
          <label class="form-label" for="startTime">Start Time</label>
          <div class="form-control time-field">
            <span>{{startTime?.value}}</span>
            <i class="bi bi-clock"></i>
          </div>
        </div>
        <div class="durationTime">
          <label class="form-label" for="duration">Duration</label>
          <div class="form-control duration-field">
            <span>{{duration?.value}}</span>
            <i class="bi bi-caret-down-fill"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 mb-2 appointmentType-container field-group">
      <label class="form-label apppointmentType-label" for="appointmentType">Appointment Type *</label>
      <div class="aptmt-type-field">
        <select class="form-select aptmt-type-select" formControlName="appointmentType" id="appointmentType">
          <option *ngFor="let aptmtType of appointmentTypes" [value]="aptmtType.lookupValue" class="select-option">
            {{aptmtType.lookupText}}</option>
        </select>
        <i class="bi bi-chevron-down aptmt-type-icon" aria-hidden="true"></i>
      </div>
    </div>
    <div class="col-12 mb-2 notes-section">
      <label class="form-label aptmt-notes-field" for="reason">Reason for Appointment</label>
      <textarea class="form-control notes-textarea" rows="3" formControlName="reason"></textarea>
    </div>
    <hr>
    <div class="form-actions text-center col-12 mbBottom">
      <button type="button" class="btn btn-secondary me-2" (click)="onHide()">Cancel</button>
      <button type="button" class="btn btn-dark" [disabled]="!isPatientValid || isScheduling"
        (click)="scheduleAppointment()">
        <span *ngIf="isScheduling" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
        {{ isScheduling ? 'Scheduling...' : 'Schedule' }}
      </button>
    </div>
  </form>
</div>